export default __webpack_public_path__ + "static/InterDisplay-ThinItalic-ac2c312ce0e8e3477c696e0d10300a95.woff2";